import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useProceedingCreate } from '@/module/Author/Proceeding/model/ProceedingQuery';
import {
  ProceedingSchema,
  defaultProceedingValues,
  proceedingSchema,
} from '@/module/Author/Proceeding/model/ProceedingSchema';

import { useAppNotification } from '@feature/utils';

import { ProceedingForm } from './ProceedingForm';

export function ProceedingCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useProceedingCreate();
  const navigate = useNavigate();
  const notification = useAppNotification();

  const onSubmit = (values: ProceedingSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newProceeding => {
        notification.success();
        navigate({ to: '/author/proceeding/$proceedingId', params: { proceedingId: String(newProceeding.id) } });
      },
    });
  };

  return (
    <ProceedingForm
      title={t('proceedings.form.title.create')}
      schema={proceedingSchema}
      defaultValues={defaultProceedingValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
      showWosFields={false}
      showScopusFields={false}
    />
  );
}
